export enum BasicModalIcon {
  Warning = 'warning',
  Help = 'help',
  Success = 'success',
  Error = 'error',
}

export enum BasicModalCta {
  Main = 'main',
  Alternative = 'alternative',
  Close = 'close',
}
